export default {"src":"/_next/static/media/ese.1e19f6c6.svg","height":46,"width":51,"blurWidth":0,"blurHeight":0};